// removed by extract-text-webpack-plugin
module.exports = {"conversion-wrapper":"conversion-wrapper__20RKD","conversion-holder":"conversion-holder__v8jek","commondenomination":"commondenomination__1PxxG","grapherror":"grapherror__e43-a"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/components/Conversionfold/ConversionFold.scss
// module id = 1150
// module chunks = 68